module.exports = __webpack_public_path__ + "static/media/instagram.803e97f2.svg";